import axios from "axios";
import moment from "moment";
import store from "@/store";
const instance = axios.create({ baseURL: store.getters.server });

export default {
  async getCep(cep) {
    try {
      let response = await instance.get("/correio/get/"+cep);
      return response.data;
    } catch (error) {
      console.log(error);
    }
  },
  
  async getPreco(cep) {
    try {
      let response = await instance.get("/correio/getpreco/"+cep);
      return response.data;
    } catch (error) {
      console.log(error);
    }
  },
  
  async getTrack(cep) {
    try {
      let response = await instance.get("/correio/gettrack/"+cep);
      return response.data;
    } catch (error) {
      console.log(error);
    }
  }
};



// WEBPACK FOOTER //
// ./src/services/buscacep.js